import React, { useEffect } from 'react'
import { FaqsCont } from './ImagesJson';
import Flip2 from './Flip2';

const FaqsTemp = () => {

    useEffect(() => {
        const handleScroll = () => {
            const bgElement = document.querySelector('.outerfaqdiv');
            const screenWidth = window.innerWidth;
            if (bgElement) {
                const scrollPosition = window.scrollY;

                if (screenWidth <= 500) {
                    bgElement.style.backgroundPosition = `center ${scrollPosition * 0.5}px`;
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className="outerfaqdiv">
                {FaqsCont.map((ele, i) => {
                    return (
                        <Flip2 question={ele.question} answer={ele.answer}/>
                    );
                })}
            </div>

        </>
    )
}

export default FaqsTemp
